<div class="wrapper-transfer">
  <app-transfer-table name="source" [transfer]="this"></app-transfer-table>
  <div class="wrapper-actions">
    <button mat-icon-button (click)="onTransferItems('source')">
      <mat-icon>arrow_right</mat-icon>
    </button>
    <button mat-icon-button (click)="onTransferItems('target')">
      <mat-icon>arrow_left</mat-icon>
    </button>
  </div>
  <app-transfer-table name="target" [transfer]="this"></app-transfer-table>
</div>
